<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Draggable from 'vuedraggable';
import { stageTypeIcon } from '../stageTypes';

// Zonas de drop "✓ Ganado / ✗ Perdido" que aparecen MIENTRAS se arrastra una
// card (patrón Kommo): con las columnas de cierre fuera del tablero, cerrar
// por drag necesita un destino cercano. Siempre montadas (ocultas por CSS):
// montar/desmontar durante un drag rompería el cálculo de targets de Sortable.
defineProps({
  wonStage: { type: Object, default: null },
  lostStage: { type: Object, default: null },
  active: { type: Boolean, default: false },
});
const emit = defineEmits(['drop']);

const { t } = useI18n();

// Listas descartables: la card que cae se emite al padre (que abre el modal de
// cierre) y la lista se vacía — la zona nunca retiene cards.
const wonList = ref([]);
const lostList = ref([]);

const handleChange = (stage, listRef) => event => {
  if (!event.added) return;
  const lead = event.added.element;
  listRef.value = [];
  emit('drop', { lead, stage });
};

const zoneClass = over =>
  `flex items-center justify-center flex-1 max-w-xs gap-2 px-4 h-16 text-sm font-medium border-2 border-dashed rounded-xl transition-colors ${over}`;
</script>

<template>
  <div
    class="absolute inset-x-4 bottom-4 z-30 flex justify-center gap-3 transition-opacity"
    :class="active ? 'opacity-100' : 'opacity-0 pointer-events-none'"
  >
    <Draggable
      v-if="wonStage"
      v-model="wonList"
      item-key="id"
      :group="{ name: 'leads', pull: false }"
      :sort="false"
      :class="
        zoneClass(
          'border-n-teal-8 bg-n-solid-1/95 text-n-teal-11 backdrop-blur'
        )
      "
      @change="handleChange(wonStage, wonList)($event)"
    >
      <template #header>
        <span
          class="flex-shrink-0 size-4"
          :class="stageTypeIcon('won')"
          aria-hidden="true"
        />
        <span class="truncate">
          {{ t('LEADS.CLOSE.DROP_WON', { stage: wonStage.name }) }}
        </span>
      </template>
      <template #item="{ element }">
        <span :key="element.id" class="hidden" />
      </template>
    </Draggable>
    <Draggable
      v-if="lostStage"
      v-model="lostList"
      item-key="id"
      :group="{ name: 'leads', pull: false }"
      :sort="false"
      :class="
        zoneClass(
          'border-n-ruby-8 bg-n-solid-1/95 text-n-ruby-11 backdrop-blur'
        )
      "
      @change="handleChange(lostStage, lostList)($event)"
    >
      <template #header>
        <span
          class="flex-shrink-0 size-4"
          :class="stageTypeIcon('lost')"
          aria-hidden="true"
        />
        <span class="truncate">
          {{ t('LEADS.CLOSE.DROP_LOST', { stage: lostStage.name }) }}
        </span>
      </template>
      <template #item="{ element }">
        <span :key="element.id" class="hidden" />
      </template>
    </Draggable>
  </div>
</template>
